<template>
<div>

    <div class="fxboex head">
        <div class="title">会员注册</div>
    </div>
<!--    <div class="tabpanel_lh"></div>-->


    <div class="account">
<!--        <div class="actnav">-->
<!--            <router-link to="/login">登录</router-link>-->
<!--            <span>注册</span>-->
<!--        </div>-->

        <div class="login register">
            <h1>用户注册</h1>
            <form>
                <div class="item item2">
                    <i class="user"/>
                    <input class="put" type="text" ref="name" v-model="account" placeholder="账号，4-10个字符" autocomplete="off"/>
                    <div class="msg" v-if="error_code===1"><b></b>4-10个字符(包括大小写字母、数字、下划线)，注册后不能修改。</div>
                </div>
                <div class="item item2">
                    <i class="pwd"/>
                    <input class="put" type="password" ref="pwd1" v-model="password" placeholder="密码，6～20位字符" autocomplete="off"/>
                    <div class="msg" v-if="error_code===2"><b></b>6～20位，区分字母大小写。可由字母、数字、特殊字符组成。</div>
                </div>
                <div class="pwdsf"><span class="nm">密码强度：</span><div :class="['ln', 'ln'+pwd_strength]"><i title="低"></i><i title="中"></i><i title="高"></i></div><span class="tx"></span></div>
                <div class="item item2">
                    <i class="pwd"/>
                    <input class="put" type="password" ref="pwd2" v-model="password2" placeholder="确认密码" autocomplete="off"/>
                    <div class="msg msg2" v-if="error_code===3"><b></b>两次密码要一致</div>
                </div>
                <div class="item code"><i class="yzm"/>
                    <input type="number" maxlength="5" class="put" ref="code" v-model="code" placeholder="验证码" autocomplete="off" />
                    <yzcode @getIdentifyCode="valcode" :changeCode="changeCode" class="code"/>
                </div>
                <div class="arg">
                    <div class="regchk"><van-checkbox v-model="isArgee" shape="square" checked-color="#f4882a"  icon-size="18px" /></div>
                    <span>注册代表你同意</span>《<div class="argtxt" @click="getTreaty">烽行体育用户协议</div>》
                </div>
                <button type="button" @click="toRegister" class="rg">立即注册</button>
                <div class="rout">
                    已有账号，请 <router-link to="/login">登录</router-link>
                </div>
            </form>
        </div>
    </div>


    <van-popup position="bottom" v-model="showTreaty" @click-overlay='closeTreaty' :duration=".1">
        <div class="fxtreaty">
            <h2>烽行体育用户协议</h2>
            <div class="treaty"><TreatyMini :showTitle="false" /></div>
            <div class="btmbtn" @click="closeTreaty(1)">我已同意用户协议</div>
        </div>
    </van-popup>

</div>
</template>

<script>
    import yzcode from '../components/public/yzcode'
    import TreatyMini from './public/treaty_mini'
    export default {
        name: "register",
        components: {
            yzcode,
            TreatyMini
        },
        data() {
            return {
                account: '',
                password: '',
                password2: '',
                code: '',
                yzm: '',
                changeCode: 0,
                isArgee: false,
                showTreaty: false,
                error_code: 0,
                pwd_strength: 0,
            }
        },
        watch: {
          'password'(v){
              this.pwd_strength = this.checkPasswordStrength(v)
          }
        },
        methods: {
            getTreaty(){
              this.showTreaty = true
            },
            closeTreaty(t=0){
              this.showTreaty = false
                if(t===1){
                    this.isArgee = true
                }
            },
            valcode(data){
                this.yzm = data
            },
            checkPasswordStrength(val) {
                /**
                 * 检查密码强度
                 * @type {number}
                 */
                var model = 0
                if (val.length < 6) return 0
                if (/\d/.test(val)) model++
                if (/[a-z]/.test(val)) model++
                if (/[A-Z]/.test(val)) model++
                if (/\W/.test(val)) model++
                if (val.length > 16) return 3
                return model
            },
            toRegister () {
                let that = this
                that.error_code = 0
                that.account = that.account.replace(/\s*/g,"")
                if(that.account === ''){
                    this.$toast('请输入账号')
                    that.account = that.account.replace(/\s*/g,"")
                    this.error_code = 1
                    this.$nextTick(() =>{
                        this.$refs.name.focus()
                    })
                    return
                }
                if(that.account.length<4 || that.account.length>10){
                    this.error_code = 1
                    that.account = that.account.replace(/\s*/g,"")
                    this.$nextTick(() =>{
                        this.$refs.name.focus()
                    })
                    return
                }
                if(that.password === ''){
                    this.$toast('请输入密码')
                    this.error_code = 2
                    this.$nextTick(() =>{
                        this.$refs.pwd1.focus()
                    })
                    return
                }
                if(that.password.length<6 || that.password.length>20){
                    this.error_code = 2
                    this.$nextTick(() =>{
                        this.$refs.pwd1.focus()
                    })
                    return
                }
                if(that.password2 === ''){
                    this.$toast('请再次输入密码')
                    this.error_code = 3
                    this.$nextTick(() =>{
                        this.$refs.pwd2.focus()
                    })
                    return
                }
                if(that.password2 !== that.password){
                    this.$toast('两次密码不一致')
                    this.error_code = 3
                    this.$nextTick(() =>{
                        this.$refs.pwd2.focus()
                    })
                    return
                }
                if(that.code === ''){
                    this.$toast('请输入验证码')
                    this.$nextTick(() =>{
                        this.$refs.code.focus()
                    })
                    return
                }
                if(that.code !== that.yzm){
                    this.$toast('验证码不正确')
                    that.code = ''
                    that.changeCode = Math.random()
                    this.$nextTick(() =>{
                        this.$refs.code.focus()
                    })
                    return
                }
                if(!that.isArgee){
                    this.$toast('请先同意用户协议')
                    return
                }
                let data = {
                    name: that.account.replace(/\s*/g,""),
                    pwd1: btoa(that.password),
                    pwd2: btoa(that.password2)
                }
                that.$post(that.$api.register, data)
                    .then(function (res) {
                    //console.log(res)
                    if(res.code === 1) {
                        that.$toast.success(res.msg)
                        that.changeCode = Math.random()
                        that.$store.commit('LOGIN', res.data.token)
                        that.$store.commit('SET_USER', res.data.user)
                        that.account = ''
                        that.password = ''
                        that.password2 = ''
                        that.code = ''
                        that.isArgee = false
                        setTimeout(function () {
                            that.$router.replace({path: '/ball'})
                        }, 50)
                    }
                    else{
                        that.$toast.fail(res.msg)
                        that.changeCode = Math.random()
                        that.code = ''
                    }
                })
            },
        },
    }
</script>

<style scoped>
    .van-popup{background: none;}
</style>
